import { ClassData } from '../services/api';

export const isMockPeekPassEvent = (event: ClassData): boolean => {
  const eventId = String(event._id || '');
  return Boolean(event.isFallback || eventId.startsWith('mock-'));
};

const getEventTime = (event: ClassData): number => {
  const time = new Date(event.createdAt || event.updatedAt || event.eventDate || '').getTime();
  return Number.isNaN(time) ? 0 : time;
};

export const sortPeekPassEvents = (events: ClassData[]): ClassData[] => (
  [...events].sort((left, right) => {
    const sourceRank = Number(isMockPeekPassEvent(left)) - Number(isMockPeekPassEvent(right));
    if (sourceRank !== 0) return sourceRank;
    return getEventTime(right) - getEventTime(left);
  })
);

export const buildPeekPassEventFeed = (apiEvents: ClassData[]): ClassData[] => {
  console.log("EVENT FEED INPUT", apiEvents.length);

  return Array.isArray(apiEvents)
    ? apiEvents.filter(Boolean)
    : [];
};
